/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/**
 * Switch between browser and server environment and return the appropriate
 * New Relic agent.
 */
const { default: isDevelopment } = require('./isDevelopment');
const { isEnd2EndTesting } = require('./isEnd2EndTesting');

let newrelic = {
  noticeError: () => {},
  addCustomAttribute: () => {},
  addPageAction: () => {},
  log: () => {},
};

if (
  process.env.NODE_ENV !== 'test' &&
  !isEnd2EndTesting() &&
  !isDevelopment()
) {
  if (typeof window !== 'undefined') {
    const {
      BrowserAgent,
    } = require('@newrelic/browser-agent/loaders/browser-agent');
    const options = {
      init: {
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ['bam.nr-data.net'] },
      },
      info: {
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: 'NRJS-e5a5f1b799a0d50a9dc',
        applicationID: '1049060931',
        sa: 1,
      },
      loader_config: {
        accountID: '3026906',
        trustKey: '3026906',
        agentID: '1049060931',
        licenseKey: 'NRJS-e5a5f1b799a0d50a9dc',
        applicationID: '1049060931',
      },
      features: [
        require('@newrelic/browser-agent/features/page_action').PageAction,
        require('@newrelic/browser-agent/features/metrics').Metrics,
        require('@newrelic/browser-agent/features/jserrors').JSErrors,
        require('@newrelic/browser-agent/features/logging').Logging,
      ],
    };
    newrelic = new BrowserAgent(options);
  } else {
    newrelic = require('newrelic');
  }
}

module.exports = newrelic;
